"use client";

import {
	classed,
	clsx,
	DialogClose,
	DialogContent,
	DialogRoot,
	DialogTrigger,
	DialogViewport,
} from "@trydig/ui";

import { SolarMinimizeSquare3Linear } from "@/components/icons/Solar";
import { XIcon } from "@/components/icons/XIcon";
import { IconButton } from "../IconButton";
import styles from "./Drawer.module.css";

const variantConfig = {
	variants: {
		color: {
			yellow: styles.colorYellow,
		},
	},
} as const;

export const DrawerRoot = DialogRoot;
export const DrawerViewport = classed(
	DialogViewport,
	styles.viewportBase,
	styles.viewport,
	{
		variants: {
			side: {
				right: styles.right,
			},
		},
	},
	variantConfig,
);
export const DrawerContent = classed(DialogContent, styles.content);
export const DrawerMain = classed("div", styles.main);

export const DrawerClose = ({ inline = false }) => {
	return (
		<DialogClose
			className={clsx(styles.close, inline && styles.inline)}
			asChild
		>
			<IconButton className={styles.closeButton}>
				<XIcon />
			</IconButton>
		</DialogClose>
	);
};
export const DrawerTrigger = DialogTrigger;

export const DrawerHeader = classed("header", styles.header, {
	variants: {
		inline: {
			true: styles.inline,
		},
	},
});
export const DrawerFooter = classed("footer", styles.footer);

export const DialogTitle = classed("h2", styles.title, {
	variants: {
		small: {
			true: styles.small,
		},
	},
});
export const DrawerTitle = DialogTitle;
export const ModalTitle = DialogTitle;

export const ModalRoot = DialogRoot;
export const ModalViewport = classed(
	DialogViewport,
	styles.viewportBase,
	styles.modalViewport,
	variantConfig,
);
export const ModalContent = classed(DialogContent, styles.content);
export const ModalMain = classed("div", styles.main);
export const ModalHeader = classed("header", styles.header);
export const ModalFooter = classed("footer", styles.footer);

export const ModalTrigger = DialogTrigger;

export const ModalClose = () => {
	return (
		<DialogClose className={styles.close} asChild>
			<IconButton>
				<SolarMinimizeSquare3Linear />
			</IconButton>
		</DialogClose>
	);
};
